import { useNavigate } from "react-router-dom";
import { X, Plus, Minus, Trash2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { inr } from "@/lib/api";

export default function CartDrawer() {
  const { items, open, setOpen, setQty, remove, total, count } = useCart();
  const navigate = useNavigate();

  return (
    <>
      <div
        className={`fixed inset-0 z-[70] bg-obsidian/50 fade-layer ${open ? "open" : ""}`}
        onClick={() => setOpen(false)}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 z-[80] h-full w-full max-w-md bg-cream flex flex-col panel-right ${open ? "open" : ""}`}
      >
        <div className="flex items-center justify-between px-7 py-6 border-b border-black/10">
          <h3 className="font-serif text-2xl">Your Cart ({count})</h3>
          <button onClick={() => setOpen(false)} data-testid="cart-close-btn" aria-label="Close cart">
            <X className="w-5 h-5" strokeWidth={1.5} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-7 py-6 space-y-6">
          {items.length === 0 && (
            <p className="font-sans text-sm text-muted-foreground">Your cart is empty.</p>
          )}
          {items.map((i) => (
            <div key={i.product_id} className="flex gap-4" data-testid={`cart-item-${i.slug}`}>
              <div className="w-20 h-24 bg-sand overflow-hidden shrink-0">
                <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1">
                <p className="font-serif text-lg leading-tight">{i.name}</p>
                <p className="font-sans text-sm text-amber-deep mt-1">{inr(i.price)}</p>
                <div className="flex items-center gap-3 mt-3">
                  <button onClick={() => setQty(i.product_id, i.quantity - 1)} className="border border-black/20 p-1 hover:bg-obsidian hover:text-cream transition-colors" aria-label="Decrease"><Minus className="w-3 h-3" /></button>
                  <span className="font-sans text-sm w-6 text-center">{i.quantity}</span>
                  <button onClick={() => setQty(i.product_id, i.quantity + 1)} className="border border-black/20 p-1 hover:bg-obsidian hover:text-cream transition-colors" aria-label="Increase"><Plus className="w-3 h-3" /></button>
                  <button onClick={() => remove(i.product_id)} className="ml-auto text-muted-foreground hover:text-destructive transition-colors" aria-label="Remove"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-black/10 px-7 py-6 space-y-4">
          <div className="flex justify-between font-sans text-sm">
            <span className="uppercase tracking-[0.2em]">Subtotal</span>
            <span className="font-serif text-xl">{inr(total)}</span>
          </div>
          <button
            data-testid="cart-checkout-btn"
            disabled={items.length === 0}
            onClick={() => { setOpen(false); navigate("/checkout"); }}
            className="w-full bg-obsidian text-cream py-4 font-sans uppercase tracking-[0.2em] text-xs hover:bg-amber-deep transition-colors disabled:opacity-40"
          >
            Checkout · Cash on Delivery
          </button>
        </div>
      </aside>
    </>
  );
}
